import {
    VERIFY_MAIL_OTP_OPERATOR_START,
    VERIFY_MAIL_OTP_OPERATOR_SUCCESS,
    VERIFY_MAIL_OTP_OPERATOR_ERROR,
    VERIFIED_MAIL_OTP_OPERATOR_START,
    VERIFIED_MAIL_OTP_OPERATOR_SUCCESS,
    VERIFIED_MAIL_OTP_OPERATOR_ERROR,
} from "../../../Constant";

const initialState = {
    loading: false,
    varifyData: {},
    verifiedData: {},
    errMsg: ''
};

export default function authReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case VERIFY_MAIL_OTP_OPERATOR_START:
            return {
                ...state,
                loading: true,
            };
        case VERIFY_MAIL_OTP_OPERATOR_SUCCESS:
            return {
                ...state,
                varifyData: action.payload,
                loading: false,
            };
        case VERIFY_MAIL_OTP_OPERATOR_ERROR:
            return {
                ...state,
                loading: false,
                errMsg: action.error.message,
            };
        case VERIFIED_MAIL_OTP_OPERATOR_START:
            return {
                ...state,
                loading: true,
            };
        case VERIFIED_MAIL_OTP_OPERATOR_SUCCESS:
            return {
                ...state,
                verifiedData: action.payload,
                loading: false,
            };
        case VERIFIED_MAIL_OTP_OPERATOR_ERROR:
            return {
                ...state,
                loading: false,
                errMsg: action.error.message,
            };
        default:
            return state;
    }
}
